module.exports = __webpack_public_path__ + "static/img/bigdata1.c8031bd.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/bigdata1.png
// module id = aXU7
// module chunks = 0